<template>
	<div class="space-y-4">
        <template v-for="notification in notificationArray">
            <notification-info>
                <div class="flex items-start justify-between w-full">
                    <p>
                        Your {{ notification.data.event }} event was rescheduled from {{ notification.data.old_event_date }}
                        to {{ notification.data.new_event_date }}
                    </p>

                    <div class="-mx-1.5 -my-1.5 pl-3">
                        <button class="inline-flex rounded-md p-1.5 focus:outline-none"
                                @click="dismiss(notification.id)"
                        >
                            <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </div>
            </notification-info>
        </template>
    </div>
</template>

<script>
    import NotificationInfo from "./Info";

	export default {
	    data() {
	        return {
	            notificationArray: []
            }
        },

		props: {
		    notifications: {
		        type: Array,
                required: true,
            }
        },

        components: { NotificationInfo },

        created() {
	        this.notificationArray = _.cloneDeep(this.notifications);
        },

        methods: {
            dismiss(id) {
                axios.delete(`/customer/notifications/${id}`)
                    .then(() => {
                        this.notificationArray = _.reject(this.notificationArray, ['id', id]);
                    });
            }
        }
    }
</script>
